import React, { ReactNode } from 'react';

import type { MobileSupportPagesType } from 'features/mobile-report/types/types';
import { mobileSupportPageSignal } from 'features/mobile-report/state/mobile-report.signals';
import { AskSupportMobile } from 'features/mobile-report/shared/components/mobile-support-pages/ask-support-mobile';
import { SupportSuccessMobile } from 'features/mobile-report/shared/components/mobile-support-pages/support-success-mobile';
import { SupportFailedMobile } from 'features/mobile-report/shared/components/mobile-support-pages/support-failed-mobile';
import { RequestLocationMobile } from 'features/mobile-report/shared/components/mobile-support-pages/request-location-mobile';

import styles from './mobile-support-pages.module.scss';

const supportPages: Record<MobileSupportPagesType, ReactNode> = {
    askSupport: <AskSupportMobile />,
    requestLocation: <RequestLocationMobile />,
    success: <SupportSuccessMobile />,
    failed: <SupportFailedMobile />,
};

export const MobileSupportPages = () => {
    if (!mobileSupportPageSignal.value) return null;

    return (
        <div className={styles.supportMobile} data-testid="mobile-support-page">
            {supportPages[mobileSupportPageSignal.value]}
        </div>
    );
};
